import { USER_TYPE } from '@/utils/constants';

export default {
  user: state => {
    return {
      name: state.userName,
      image: state.userImage,
      isSuperAdmin: state.isSuperAdmin,
    };
  },
  userType: state => {
    return state.user ? USER_TYPE.EDITOR : USER_TYPE.GUEST;
  },
  isEditor: (state, getters) => {
    return Boolean(getters.userType === USER_TYPE.EDITOR);
  },
  isInternational: state => {
    return state.user ? state.user.international : false;
  },
};
